/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Agent_Plugin_Cap_FailedInputs */



/**
* | output |
* | --- |
* | "The limit could not be saved: {message}" |
*
* @param {Agent_Plugin_Cap_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_cap_failed = /** @type {((inputs: Agent_Plugin_Cap_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Cap_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`La limite n'a pas pu être enregistrée : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Limit konnte nicht gespeichert werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile salvare il limite: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось сохранить лимит: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo guardar el límite: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`限制无法保存：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`制限値を保存できませんでした: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सीमा सहेजी नहीं जा सकी: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível salvar o limite: ${i?.message}`)
	return /** @type {LocalizedString} */ (`The limit could not be saved: ${i?.message}`)
});